import { PalletPattern } from '@/model'

export function createPatternObject () {
  const palletPattern: PalletPattern = {
    guid: '',
    name: '',
    created: new Date(),
    updated: new Date(),
    box: {
      ignoreBoxLimitations: false
    },
    pallet: {
      layerPatterns: [],
      layers: [],
      interlayerSheetPositions: []
    },
    programSettings: {},
    machineSettings: {}
  }
  return palletPattern
}

export function copyPatternObject (pattern: PalletPattern) {
  const palletPattern: PalletPattern = {
    guid: '',
    name: pattern.name,
    created: new Date(),
    updated: new Date(),
    box: pattern.box,
    pallet: pattern.pallet,
    programSettings: pattern.programSettings,
    machineSettings: pattern.machineSettings
  }
  return palletPattern
}

export interface CustomData {
  key: string,
  value: any
}
